import { AbstractControl, ValidatorFn } from '@angular/forms';

export class TrackingValidator {

 static templateMessages = {
    myValidator: 'El valor debe de estar comprendido entre 1 y 5.',
    myParamValidator: 'El valor debe estar comprendido entre 3 y 15.',
    required: 'Introduzca un valor para el campo.',
    email: 'Introduza un email válido.',
    maxlength: 'Se ha superado el valor máximo de caracteres.',
    minlength: 'Se requiere un número mayor de caracteres.'
 };

// -----------------------------------
//      VALIDADORES CUSTOMIZADOS
// -----------------------------------

 // Validador sin parámetros.
 static myValidator(c: AbstractControl): {[key: string]: boolean} | null {
    if (c.value !== null && (isNaN(c.value) || c.value < 1 || c.value > 5)) {
       return {'myValidator': true};
    }
    return null;
 } // End function myValidator

 // Validador con parámetros.
 static myParamValidator(min: number, max: number): ValidatorFn {
  return(c: AbstractControl): {[key: string]: boolean} | null  => {
      if (c.value !== null && (isNaN(c.value) || c.value < min || c.value > max)) {
        return {'myParamValidator': true};
      }
      return null;
  };
 } // End function myParamValidator

} // End class TrackingValidator
